var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedChevronLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48419 0.650831C6.12669 0.293331 5.54919 0.293331 5.19169 0.650831L0.984189 4.85833C0.626689 5.21583 0.626689 5.79333 0.984189 6.15083L5.19169 10.3583C5.54919 10.7158 6.12669 10.7158 6.48419 10.3583C6.84169 10.0008 6.84169 9.42333 6.48419 9.06583L2.92752 5.5L6.48419 1.94333C6.84169 1.58583 6.83252 0.999164 6.48419 0.650831Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedChevronLeftIcon);
export default __webpack_public_path__ + "static/media/DeprecatedChevronLeftIcon.74376be21d7749447d0674a50683f922.svg";
export { ForwardRef as ReactComponent };